import { render, staticRenderFns } from "./CallContactSetup.vue?vue&type=template&id=447b8fc3&scoped=true"
import script from "./CallContactSetup.vue?vue&type=script&lang=ts"
export * from "./CallContactSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b8fc3",
  null
  
)

export default component.exports